import { cn } from "@pcln/horizon";
const toWideBreakpoint = (singleRow)=>singleRow ? '5xl' : '7xl';
const variantFormContainer = {
    single: [
        'single'
    ],
    singleWithSelectedFilters: [
        'single'
    ],
    singleWithFlights: [
        'single'
    ],
    singleSticky: [
        'single sticky'
    ],
    singleWithSelectedFiltersSticky: [
        'single sticky'
    ],
    singleWithFlightsSticky: [
        'single sticky'
    ],
    multi: 'multi'
};
const variantGridContainer = {
    single: {
        '7xl': [
            'grid-cols-1 gap-3 auto-rows-auto items-center',
            "[grid-template-areas:'location-input'_'date-picker'_'travelers'_'pkg-deals'_'submit-btn']",
            "@3xl:grid-cols-2 @3xl:[grid-template-areas:'location-input_location-input'_'date-picker_travelers'_'pkg-deals_submit-btn']",
            '@7xl:grid-cols-[1fr_1fr_1fr_max-content]',
            "@7xl:[grid-template-areas:'location-input_date-picker_travelers_submit-btn'_'pkg-deals_pkg-deals_pkg-deals_pkg-deals']"
        ],
        '5xl': [
            'grid-cols-1 gap-3 auto-rows-auto items-center',
            "[grid-template-areas:'location-input'_'date-picker'_'travelers'_'pkg-deals'_'submit-btn']",
            "@3xl:grid-cols-2 @3xl:[grid-template-areas:'location-input_location-input'_'date-picker_travelers'_'pkg-deals_submit-btn']",
            '@5xl:grid-cols-[1fr_1fr_1fr_max-content]',
            "@5xl:[grid-template-areas:'location-input_date-picker_travelers_submit-btn'_'pkg-deals_pkg-deals_pkg-deals_pkg-deals']"
        ]
    },
    singleWithSelectedFilters: {
        '7xl': [
            'grid-cols-1 gap-3 auto-rows-auto items-center',
            "[grid-template-areas:'location-input'_'selected-filters'_'date-picker'_'travelers'_'pkg-deals'_'submit-btn']",
            "@3xl:grid-cols-2 @3xl:[grid-template-areas:'location-input_location-input'_'selected-filters_selected-filters'_'date-picker_travelers'_'pkg-deals_submit-btn']",
            '@7xl:grid-cols-[1fr_1fr_1fr_max-content]',
            "@7xl:[grid-template-areas:'location-input_date-picker_travelers_submit-btn'_'selected-filters_selected-filters_selected-filters_selected-filters'_'pkg-deals_pkg-deals_pkg-deals_pkg-deals']"
        ],
        '5xl': [
            'grid-cols-1 gap-3 auto-rows-auto items-center',
            "[grid-template-areas:'location-input'_'selected-filters'_'date-picker'_'travelers'_'pkg-deals'_'submit-btn']",
            "@3xl:grid-cols-2 @3xl:[grid-template-areas:'location-input_location-input'_'selected-filters_selected-filters'_'date-picker_travelers'_'pkg-deals_submit-btn']",
            '@5xl:grid-cols-[1fr_1fr_1fr_max-content]',
            "@5xl:[grid-template-areas:'location-input_date-picker_travelers_submit-btn'_'selected-filters_selected-filters_selected-filters_selected-filters'_'pkg-deals_pkg-deals_pkg-deals_pkg-deals']"
        ]
    },
    singleWithFlights: {
        '7xl': [
            'grid-cols-1 gap-3 auto-rows-auto items-center',
            "[grid-template-areas:'flight-input'_'location-input'_'date-picker'_'travelers'_'pkg-deals'_'submit-btn']",
            "@3xl:grid-cols-2 @3xl:[grid-template-areas:'flight-input_location-input'_'date-picker_travelers'_'pkg-deals_submit-btn']",
            '@7xl:grid-cols-[minmax(0,0.8fr)_minmax(0,0.8fr)_minmax(0,1fr)_minmax(0,1fr)_max-content]',
            "@7xl:[grid-template-areas:'flight-input_location-input_date-picker_travelers_submit-btn'_'pkg-deals_pkg-deals_pkg-deals_pkg-deals_pkg-deals']"
        ],
        '5xl': [
            'grid-cols-1 gap-3 auto-rows-auto items-center',
            "[grid-template-areas:'flight-input'_'location-input'_'date-picker'_'travelers'_'pkg-deals'_'submit-btn']",
            "@3xl:grid-cols-2 @3xl:[grid-template-areas:'flight-input_location-input'_'date-picker_travelers'_'pkg-deals_submit-btn']",
            '@5xl:grid-cols-[minmax(0,0.8fr)_minmax(0,0.8fr)_minmax(0,1fr)_minmax(0,1fr)_max-content]',
            "@5xl:[grid-template-areas:'flight-input_location-input_date-picker_travelers_submit-btn'_'pkg-deals_pkg-deals_pkg-deals_pkg-deals_pkg-deals']"
        ]
    },
    singleSticky: {
        '7xl': [
            'grid-cols-1 gap-2 auto-rows-auto',
            "[grid-template-areas:'location-input'_'date-picker'_'travelers'_'pkg-deals'_'submit-btn']",
            '@3xl:grid-cols-[1fr_1fr_1fr_max-content] @3xl:gap-3',
            "@3xl:[grid-template-areas:'location-input_date-picker_travelers_submit-btn'_'pkg-deals_pkg-deals_pkg-deals_pkg-deals']",
            'items-center text-left'
        ],
        '5xl': [
            'grid-cols-1 gap-2 auto-rows-auto',
            "[grid-template-areas:'location-input'_'date-picker'_'travelers'_'pkg-deals'_'submit-btn']",
            '@3xl:grid-cols-2 @3xl:gap-3',
            "@3xl:[grid-template-areas:'location-input_location-input'_'date-picker_travelers'_'pkg-deals_submit-btn']",
            '@5xl:grid-cols-[1fr_1fr_1fr_max-content] @5xl:gap-3',
            "@5xl:[grid-template-areas:'location-input_date-picker_travelers_submit-btn'_'pkg-deals_pkg-deals_pkg-deals_pkg-deals']",
            'items-center text-left'
        ]
    },
    singleWithSelectedFiltersSticky: {
        '7xl': [
            'grid-cols-1 gap-2 auto-rows-auto',
            "[grid-template-areas:'location-input'_'date-picker'_'travelers'_'selected-filters'_'pkg-deals'_'submit-btn']",
            '@3xl:grid-cols-[1fr_1fr_1fr_max-content] @3xl:gap-3',
            "@3xl:[grid-template-areas:'location-input_date-picker_travelers_submit-btn'_'selected-filters_selected-filters_selected-filters_selected-filters'_'pkg-deals_pkg-deals_pkg-deals_pkg-deals']",
            'items-center text-left'
        ],
        '5xl': [
            'grid-cols-1 gap-2 auto-rows-auto',
            "[grid-template-areas:'location-input'_'date-picker'_'travelers'_'selected-filters'_'pkg-deals'_'submit-btn']",
            '@3xl:grid-cols-2 @3xl:gap-3',
            "@3xl:[grid-template-areas:'location-input_location-input'_'selected-filters_selected-filters'_'date-picker_travelers'_'pkg-deals_submit-btn']",
            '@5xl:grid-cols-[1fr_1fr_1fr_max-content] @5xl:gap-3',
            "@5xl:[grid-template-areas:'location-input_date-picker_travelers_submit-btn'_'selected-filters_selected-filters_selected-filters_selected-filters'_'pkg-deals_pkg-deals_pkg-deals_pkg-deals']",
            'items-center text-left'
        ]
    },
    singleWithFlightsSticky: {
        '7xl': [
            'grid-cols-1 gap-2 auto-rows-auto',
            "[grid-template-areas:'flight-input'_'location-input'_'date-picker'_'travelers'_'pkg-deals'_'submit-btn']",
            '@3xl:grid-cols-[minmax(0,1.2fr)_minmax(0,1.2fr)_minmax(0,1fr)_minmax(0,0.8fr)_max-content] @3xl:gap-3',
            "@3xl:[grid-template-areas:'flight-input_location-input_date-picker_travelers_submit-btn'_'pkg-deals_pkg-deals_pkg-deals_pkg-deals_pkg-deals']",
            'items-center text-left'
        ],
        '5xl': [
            'grid-cols-1 gap-2 auto-rows-auto',
            "[grid-template-areas:'flight-input'_'location-input'_'date-picker'_'travelers'_'pkg-deals'_'submit-btn']",
            '@3xl:grid-cols-2 @3xl:gap-3',
            "@3xl:[grid-template-areas:'flight-input_location-input'_'date-picker_travelers'_'pkg-deals_submit-btn']",
            '@5xl:grid-cols-[minmax(0,1.2fr)_minmax(0,1.2fr)_minmax(0,1fr)_minmax(0,0.8fr)_max-content] @5xl:gap-3',
            "@5xl:[grid-template-areas:'flight-input_location-input_date-picker_travelers_submit-btn'_'pkg-deals_pkg-deals_pkg-deals_pkg-deals_pkg-deals']",
            'items-center text-left'
        ]
    },
    multi: {
        '7xl': 'grid-cols-1',
        '5xl': 'grid-cols-1'
    }
};
const backButtonGridOverrides = {
    single: {
        '7xl': cn('@7xl:grid-cols-[max-content_1fr_1fr_1fr_max-content]', "@7xl:[grid-template-areas:'back-btn_location-input_date-picker_travelers_submit-btn'_'pkg-deals_pkg-deals_pkg-deals_pkg-deals_pkg-deals']"),
        '5xl': cn('@5xl:grid-cols-[max-content_1fr_1fr_1fr_max-content]', "@5xl:[grid-template-areas:'back-btn_location-input_date-picker_travelers_submit-btn'_'pkg-deals_pkg-deals_pkg-deals_pkg-deals_pkg-deals']")
    },
    singleSticky: {
        '7xl': cn('@3xl:grid-cols-[max-content_1fr_1fr_1fr_max-content]', "@3xl:[grid-template-areas:'back-btn_location-input_date-picker_travelers_submit-btn'_'pkg-deals_pkg-deals_pkg-deals_pkg-deals_pkg-deals']"),
        '5xl': cn('@5xl:grid-cols-[max-content_1fr_1fr_1fr_max-content]', "@5xl:[grid-template-areas:'back-btn_location-input_date-picker_travelers_submit-btn'_'pkg-deals_pkg-deals_pkg-deals_pkg-deals_pkg-deals']")
    },
    singleWithSelectedFilters: {
        '7xl': cn('@7xl:grid-cols-[max-content_1fr_1fr_1fr_max-content]', "@7xl:[grid-template-areas:'back-btn_location-input_date-picker_travelers_submit-btn'_'selected-filters_selected-filters_selected-filters_selected-filters_selected-filters'_'pkg-deals_pkg-deals_pkg-deals_pkg-deals_pkg-deals']"),
        '5xl': cn('@5xl:grid-cols-[max-content_1fr_1fr_1fr_max-content]', "@5xl:[grid-template-areas:'back-btn_location-input_date-picker_travelers_submit-btn'_'selected-filters_selected-filters_selected-filters_selected-filters_selected-filters'_'pkg-deals_pkg-deals_pkg-deals_pkg-deals_pkg-deals']")
    },
    singleWithSelectedFiltersSticky: {
        '7xl': cn('@3xl:grid-cols-[max-content_1fr_1fr_1fr_max-content]', "@3xl:[grid-template-areas:'back-btn_location-input_date-picker_travelers_submit-btn'_'selected-filters_selected-filters_selected-filters_selected-filters_selected-filters'_'pkg-deals_pkg-deals_pkg-deals_pkg-deals_pkg-deals']"),
        '5xl': cn('@5xl:grid-cols-[max-content_1fr_1fr_1fr_max-content]', "@5xl:[grid-template-areas:'back-btn_location-input_date-picker_travelers_submit-btn'_'selected-filters_selected-filters_selected-filters_selected-filters_selected-filters'_'pkg-deals_pkg-deals_pkg-deals_pkg-deals_pkg-deals']")
    },
    singleWithFlights: {
        '7xl': cn('@7xl:grid-cols-[max-content_minmax(0,0.8fr)_minmax(0,0.8fr)_minmax(0,1fr)_minmax(0,1fr)_max-content]', "@7xl:[grid-template-areas:'back-btn_flight-input_location-input_date-picker_travelers_submit-btn'_'pkg-deals_pkg-deals_pkg-deals_pkg-deals_pkg-deals_pkg-deals']"),
        '5xl': cn('@5xl:grid-cols-[max-content_minmax(0,0.8fr)_minmax(0,0.8fr)_minmax(0,1fr)_minmax(0,1fr)_max-content]', "@5xl:[grid-template-areas:'back-btn_flight-input_location-input_date-picker_travelers_submit-btn'_'pkg-deals_pkg-deals_pkg-deals_pkg-deals_pkg-deals_pkg-deals']")
    },
    singleWithFlightsSticky: {
        '7xl': cn('@3xl:grid-cols-[max-content_minmax(0,1.2fr)_minmax(0,1.2fr)_minmax(0,1fr)_minmax(0,0.8fr)_max-content]', "@3xl:[grid-template-areas:'back-btn_flight-input_location-input_date-picker_travelers_submit-btn'_'pkg-deals_pkg-deals_pkg-deals_pkg-deals_pkg-deals_pkg-deals']"),
        '5xl': cn('@5xl:grid-cols-[max-content_minmax(0,1.2fr)_minmax(0,1.2fr)_minmax(0,1fr)_minmax(0,0.8fr)_max-content]', "@5xl:[grid-template-areas:'back-btn_flight-input_location-input_date-picker_travelers_submit-btn'_'pkg-deals_pkg-deals_pkg-deals_pkg-deals_pkg-deals_pkg-deals']")
    }
};
const backButtonVisibilityClass = {
    '3xl': '@3xl:inline-flex',
    '5xl': '@5xl:inline-flex',
    '7xl': '@7xl:inline-flex'
};
const getWideRowPrefix = (hotelTypeVariant, singleRowWideBreakpoint)=>hotelTypeVariant.endsWith('Sticky') && '7xl' === singleRowWideBreakpoint ? '3xl' : singleRowWideBreakpoint;
const hotelFormSlots = {
    formContainer: 'search-form-container @container w-auto',
    gridContainer: 'grid-container grid w-full [grid-area:grid-container]',
    locationInput: 'location-input [grid-area:location-input]',
    flightInput: 'flight-input [grid-area:flight-input]',
    datePicker: 'date-picker [grid-area:date-picker] ',
    travelersInput: 'travelers-selection [grid-area:travelers] ',
    packageDeals: 'pkg-deals [grid-area:pkg-deals] flex flex-row items-center @3xl:self-stretch @3xl:items-stretch',
    packageDealsSticky: 'pkg-deals mb-4 mt-0 w-full min-w-0 [grid-area:pkg-deals] flex flex-row items-center',
    submitButton: '[grid-area:submit-btn]',
    selectedFilters: 'selected-filters [grid-area:selected-filters]',
    backButton: 'hidden shrink-0 items-center whitespace-nowrap [grid-area:back-btn]'
};
const getHotelTypeVariant = (addFlights, isStickyInEffect = false, addSelectedFilters = false)=>{
    if (isStickyInEffect) {
        if (addFlights) return 'singleWithFlightsSticky';
        if (addSelectedFilters) return 'singleWithSelectedFiltersSticky';
        return 'singleSticky';
    }
    if (addSelectedFilters && !addFlights) return 'singleWithSelectedFilters';
    return addFlights ? 'singleWithFlights' : 'single';
};
const getItineraryBarContainerClass = (isStickyInEffect)=>cn('@container w-auto', isStickyInEffect && 'w-full min-w-0');
const getFormContainerClass = (addFlights, isStickyInEffect, addSelectedFilters)=>{
    const hotelTypeVariant = getHotelTypeVariant(addFlights, isStickyInEffect, addSelectedFilters);
    return cn(hotelFormSlots.formContainer, variantFormContainer[hotelTypeVariant], isStickyInEffect && 'w-full min-w-0');
};
const getGridContainerClass = (addFlights, isStickyInEffect, addSelectedFilters, singleRow = false, hasBackButton = false)=>{
    const hotelTypeVariant = getHotelTypeVariant(addFlights, isStickyInEffect, addSelectedFilters);
    const singleRowWideBreakpoint = toWideBreakpoint(singleRow);
    const gridContainer = variantGridContainer[hotelTypeVariant][singleRowWideBreakpoint];
    return cn(hotelFormSlots.gridContainer, gridContainer, hasBackButton && backButtonGridOverrides[hotelTypeVariant]?.[singleRowWideBreakpoint]);
};
const getInputClass = (type, isStickyInEffect = false)=>{
    const inputMap = {
        location: hotelFormSlots.locationInput,
        flight: hotelFormSlots.flightInput,
        datePicker: hotelFormSlots.datePicker,
        travelers: hotelFormSlots.travelersInput,
        packageDeals: isStickyInEffect ? hotelFormSlots.packageDealsSticky : hotelFormSlots.packageDeals,
        submit: hotelFormSlots.submitButton,
        selectedFilters: hotelFormSlots.selectedFilters,
        back: hotelFormSlots.backButton
    };
    return inputMap[type];
};
const WIDE_ROW_BREAKPOINT_PX = {
    '3xl': 768,
    '5xl': 1024,
    '7xl': 1280
};
const getWideLayoutBreakpointPx = (addFlights, isStickyInEffect, addSelectedFilters, singleRow = false)=>{
    const hotelTypeVariant = getHotelTypeVariant(addFlights, isStickyInEffect, addSelectedFilters);
    const prefix = getWideRowPrefix(hotelTypeVariant, toWideBreakpoint(singleRow));
    return WIDE_ROW_BREAKPOINT_PX[prefix];
};
const getBackButtonClass = (addFlights, isStickyInEffect, addSelectedFilters, singleRow = false)=>{
    const hotelTypeVariant = getHotelTypeVariant(addFlights, isStickyInEffect, addSelectedFilters);
    const prefix = getWideRowPrefix(hotelTypeVariant, toWideBreakpoint(singleRow));
    return cn(getInputClass('back', isStickyInEffect), backButtonVisibilityClass[prefix]);
};
export { getBackButtonClass, getFormContainerClass, getGridContainerClass, getInputClass, getItineraryBarContainerClass, getWideLayoutBreakpointPx };
